export default "__VITE_ASSET__D1cpTw_Y__"